import {BASE_API} from "../index";

export const SetorApi = {
  get: async () => {
    let response = await fetch(`${BASE_API}/setor`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      }
    })
    return await response.json();
  }
}